import { Grid } from "@mui/material";
import FilterDatePicker from "components/FilterDatePicker";
import { endOfDay } from "date-fns";
import { useIntl } from "react-intl";

type EventEndDatePickerProps = {
  value?: Date;
  onChange: (value: Date | undefined) => void;
};

export default function EventEndDatePicker({
  value,
  onChange,
}: EventEndDatePickerProps) {
  const { formatMessage: t } = useIntl();

  const onChangeInternal = (date: Date | undefined) => {
    onChange(date ? endOfDay(date) : date);
  };

  return (
    <Grid item xs={12} sm={12} md={4}>
      <FilterDatePicker
        label={t({ id: "to" })}
        value={value}
        onChange={onChangeInternal}
      />
    </Grid>
  );
}
